
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import mwx from '../../store/modules/mediumwarex';
import { download } from '../../util/download';

@Component({
	components: {},
})
export default class Installer extends Vue {
	public get installer32bit() {
		return mwx.installer32bit;
	}
	public get installer64bit() {
		return mwx.installer64bit;
	}
	public get version() {
		return ` v${mwx.installerVersion}`;
	}
 }
